import { Banner } from "@/components/flexkit/Banner";
import IconMoneyHand from "central-icons/IconMoneyHand";

function FreeCreditsPromotionBanner({ className }: { className?: string }) {
    return (
        <Banner
            className={className}
            text={<span className="text-content-primary">Upgrade to Core today and get $100 in free credits</span>}
            variant="info"
            role="alert"
            aria-live="assertive"
            LeadingIcon={<IconMoneyHand className="shrink-0 text-content-primary" />}
        />
    );
}

export default FreeCreditsPromotionBanner;
